<router-outlet></router-outlet>
<p-toast></p-toast>
<p-confirmDialog #cd [style]="{width: '450px'}">
  <ng-template pTemplate="footer">
    <button pButton type="button" [icon]="cd.confirmation?.rejectIcon || 'pi pi-times'" [label]="cd.confirmation?.rejectLabel || 'No'" (click)="cd.reject()" class="p-button-text !text-gray-500 hover:!bg-gray-100"></button>
    <button pButton type="button" [icon]="cd.confirmation?.acceptIcon || 'pi pi-check'" [label]="cd.confirmation?.acceptLabel || 'Yes'" (click)="cd.accept()" [class]="cd.confirmation?.acceptButtonStyleClass || 'p-button-primary'"></button>
  </ng-template>
</p-confirmDialog>
<app-receipt></app-receipt>
